import SvgIcon from '@/components/SvgIcon';
import { forwardRef } from 'react';

const AllProductIconSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_305_2557)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.85 8.7C13.5897 8.7 15 10.1103 15 11.85C15 13.54 13.6691 14.9191 11.9983 14.9966L11.85 15C10.1103 15 8.7 13.5897 8.7 11.85V8.7H11.85ZM7.3 8.7V11.85C7.3 13.54 5.96913 14.9191 4.29829 14.9966L4.15 15C2.4103 15 1 13.5897 1 11.85C1 10.1103 2.4103 8.7 4.15 8.7H7.3ZM11.85 10.1H10.0993L10.1 11.85C10.1 12.8165 10.8835 13.6 11.85 13.6C12.8165 13.6 13.6 12.8165 13.6 11.85C13.6 10.9222 12.8779 10.163 11.9651 10.1037L11.85 10.1ZM5.9 10.0993L4.15 10.1C3.1835 10.1 2.4 10.8835 2.4 11.85C2.4 12.8165 3.1835 13.6 4.15 13.6C5.07784 13.6 5.83703 12.8779 5.89628 11.9651L5.9 11.85V10.0993ZM4.15 1C5.8897 1 7.3 2.4103 7.3 4.15V7.3H4.15C2.4103 7.3 1 5.8897 1 4.15C1 2.46001 2.33087 1.08086 4.00171 1.00343L4.15 1ZM11.85 1C13.5897 1 15 2.4103 15 4.15C15 5.8897 13.5897 7.3 11.85 7.3H8.7V4.15C8.7 2.46001 10.0309 1.08086 11.7017 1.00343L11.85 1ZM4.15 2.4C3.1835 2.4 2.4 3.1835 2.4 4.15C2.4 5.07784 3.12208 5.83703 4.03494 5.89628L4.15 5.9H5.9V4.15C5.9 3.22216 5.17792 2.46297 4.26506 2.40372L4.15 2.4ZM11.85 2.4C10.9222 2.4 10.163 3.12208 10.1037 4.03494L10.1 4.15V5.9H11.85C12.7778 5.9 13.537 5.17792 13.5963 4.26506L13.6 4.15C13.6 3.1835 12.8165 2.4 11.85 2.4Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_305_2557">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const AllProductIcon = (props) => {
  return <SvgIcon component={AllProductIconSvg} {...props} />;
};
export default forwardRef(AllProductIcon);
